<template>
  <div @click="toggleConversation" class="btn-chat bg-green-light2 w-14 h-14 rounded-full flex items-center justify-center">
    <svg width="32" height="32" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.5427 4.50833C26.7695 3.01933 24.7072 1.91353 22.4857 1.26054C21.1255 0.844201 19.7203 0.592241 18.3001 0.51004C17.6059 0.467438 16.9098 0.467438 16.2156 0.51004C15.3049 0.555746 14.3977 0.654229 13.4984 0.804996C11.5922 1.14922 9.75802 1.8141 8.074 2.77137C5.80807 3.99782 3.90114 5.79386 2.54139 7.98225C1.66136 9.36477 1.07261 10.9123 0.811116 12.5301C0.549626 14.1479 0.620899 15.802 1.02058 17.3913C1.67314 20.0602 3.15168 22.455 5.24542 24.2343C7.86451 26.526 11.1192 27.9663 14.5768 28.3637C14.9725 28.3857 15.3433 28.5636 15.6081 28.8584C15.8729 29.1533 16.01 29.541 15.9894 29.9368V30.0351C15.9597 30.5737 15.8974 31.1099 15.8026 31.641C15.6996 32.0377 15.6762 32.451 15.7338 32.8568C15.7397 32.9655 15.788 33.0675 15.8682 33.141C15.9485 33.2145 16.0544 33.2537 16.1631 33.2501H16.1959C16.5331 33.2064 16.8634 33.1205 17.1792 32.9945C18.578 32.3461 19.905 31.5531 21.1386 30.6283C23.8762 28.6938 26.4611 26.5518 28.8704 24.2212C29.7096 23.4514 30.4694 22.5994 31.1386 21.678C32.6125 19.5916 33.4131 17.1043 33.4329 14.5499C33.4336 13.4164 33.2781 12.2883 32.9707 11.1973C32.204 8.57172 30.6603 6.23979 28.5427 4.50833ZM10.3978 17.1062C10.0244 17.1088 9.65861 17.0004 9.34689 16.7948C9.03518 16.5892 8.79158 16.2956 8.64702 15.9513C8.50246 15.607 8.46346 15.2275 8.53495 14.861C8.60645 14.4945 8.78523 14.1575 9.0486 13.8928C9.31197 13.6281 9.64805 13.4476 10.0142 13.3742C10.3804 13.3007 10.7601 13.3378 11.1051 13.4805C11.4502 13.6232 11.7451 13.8653 11.9524 14.1759C12.1597 14.4865 12.27 14.8516 12.2693 15.225V15.2644C12.2599 15.755 12.0588 16.2225 11.709 16.5667C11.3592 16.9109 10.8886 17.1046 10.3978 17.1062ZM17.0252 17.1062C16.653 17.103 16.2901 16.9896 15.9823 16.7805C15.6744 16.5713 15.4354 16.2757 15.2954 15.9309C15.1554 15.5861 15.1206 15.2075 15.1954 14.843C15.2702 14.4784 15.4513 14.1442 15.7159 13.8824C15.9804 13.6207 16.3165 13.4431 16.6819 13.372C17.0472 13.301 17.4254 13.3397 17.7688 13.4833C18.1121 13.6269 18.4053 13.869 18.6112 14.1789C18.8172 14.4889 18.9268 14.8529 18.9262 15.225C18.921 15.7261 18.7185 16.2048 18.3627 16.5576C18.0068 16.9104 17.5262 17.1086 17.0252 17.1095V17.1062ZM23.6918 17.1062C23.3185 17.1082 22.9531 16.9992 22.6418 16.7932C22.3305 16.5872 22.0874 16.2933 21.9433 15.949C21.7993 15.6046 21.7608 15.2253 21.8326 14.859C21.9045 14.4927 22.0835 14.156 22.347 13.8916C22.6105 13.6272 22.9466 13.447 23.3127 13.3739C23.6788 13.3007 24.0583 13.338 24.4032 13.4808C24.7481 13.6236 25.0428 13.8657 25.2499 14.1762C25.457 14.4867 25.5673 14.8518 25.5666 15.225C25.5675 15.7234 25.3706 16.2017 25.0191 16.555C24.6676 16.9083 24.1902 17.1077 23.6918 17.1095V17.1062Z"
        fill="#3D7F7F"
      />
    </svg>  
    <div class="badge bg-orange-primary rounded-xl py-1 px-1.5 text-white text-sm" v-if="newMessagesCount > 0">
      {{ newMessagesCount > 9 ? "9+" : newMessagesCount }}
    </div>
  </div>
</template>

<script>
import {useApp} from "@composables/app"
import { useConversation } from "@composables/conversation";

export default {
  setup() {
    const { newMessagesCount } = useConversation()

    const {
      toggleConversation,
    } = useApp()

    return {
      newMessagesCount,

      toggleConversation
    }
  }
};
</script>

<style scoped>
  .btn-chat {
    position: absolute;
    right: 0.6rem;
    top: 4.2rem;
  }

  .badge {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>
